<app-dropdown 
    [options]="stationEnergies" 
    [valueFormControl]="valueFormControl" 
    [isMultiSelect]="true"
    [showToggleAll]="true"
    [fieldPlaceholder]="'export-creation.fields.energy.placeholder' | translate">
</app-dropdown>